import { render, staticRenderFns } from "./DepositSubmission.vue?vue&type=template&id=63ded87d&scoped=true"
import script from "./DepositSubmission.vue?vue&type=script&lang=js"
export * from "./DepositSubmission.vue?vue&type=script&lang=js"
import style0 from "./DepositSubmission.vue?vue&type=style&index=0&id=63ded87d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ded87d",
  null
  
)

export default component.exports